import { render } from "./emp_separation_exit.vue?vue&type=template&id=0aafc307&scoped=true"
import script from "./emp_separation_exit.vue?vue&type=script&lang=js"
export * from "./emp_separation_exit.vue?vue&type=script&lang=js"

import "./emp_separation_exit.vue?vue&type=style&index=0&id=0aafc307&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aafc307"]])

export default __exports__